import React, { FunctionComponent } from 'react'
import EasySoftwareEditorContainer from 'Root/Shared/components/EasySoftwareEditorContainer/EasySoftwareEditorContainer'
import { PuxWysiwygHtmlBodyType } from 'Shared/components/PuxWysiwyg/PuxWysiwyg'

interface PlansTableEnterprisePanelProps {
  content: PuxWysiwygHtmlBodyType
  editorPath: string
  modifier?: `desktop`
  pageContentItemId: string
  style?: React.CSSProperties
  wysiwygId: string
}

const PlansTableEnterprisePanel: FunctionComponent<PlansTableEnterprisePanelProps> = ({
  content,
  editorPath,
  modifier,
  pageContentItemId,
  style,
  wysiwygId,
}) => (
  <div
    className={`PlansTable-enterprise-content${
      modifier ? ` PlansTable-enterprise-content--${modifier}` : ``
    }`}
    style={style}
  >
    <EasySoftwareEditorContainer
      wysiwygId={wysiwygId}
      content={content}
      pageContentItemId={pageContentItemId}
      editorPath={editorPath}
    />
  </div>
)

export default PlansTableEnterprisePanel
